import { render, staticRenderFns } from "./Remind.vue?vue&type=template&id=7397352c&scoped=true"
import script from "./Remind.vue?vue&type=script&lang=js"
export * from "./Remind.vue?vue&type=script&lang=js"
import style0 from "./Remind.vue?vue&type=style&index=0&id=7397352c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7397352c",
  null
  
)

export default component.exports